/**
 * La clé d'une demande paginée : ses paramètres de route et d'URL, sans la page. Deux réponses de
 * même clé sont deux pages de la même liste.
 */
export function pagedRequestKey({ routeParams, urlParams } = {}) {
    const filters = { ...urlParams }
    delete filters.page
    const entries = (params) =>
        Object.keys(params ?? {})
            .sort()
            .map((key) => [key, String(params[key])])
    return JSON.stringify([entries(routeParams), entries(filters)])
}

/**
 * Une réponse rangée dans `state.api` est dépassée quand la liste ne demande plus ces paramètres :
 * une recherche changée pendant que l'ancienne était en vol. Arrivée après la bonne, elle ne doit
 * pas fixer le curseur, sinon la pagination s'arrête à la dernière page de l'ancienne recherche.
 */
export function isSupersededResponse(response, routeParams, urlParams) {
    return (
        pagedRequestKey(response) !==
        pagedRequestKey({ routeParams: routeParams ?? {}, urlParams })
    )
}
